<template>
  <content-page :class="$setClasses" :title="title">
    <template v-slot:header>
      <slot name="content-header"></slot>
    </template>
    <slot name="header"></slot>
    <el-card :class="$vClass('content_card')">
      <slot name="before"></slot>
      <div v-if="subtitle"
           :class="$vClass('header')">
        <h2 :class="$vClass('subtitle')" v-html="subtitle"></h2>
      </div>
      <div v-show="otherLoading" class="loader">
        <loading-icon class="--primary" />
        <div class="loader__text">{{ loadingText }}</div>
      </div>
      <div v-show="!otherLoading" :class="$vClass('content_wrapper')">
        <slot></slot>
      </div>

      <sticky-card-footer :class="[$vClass('footer')]">
        <div :class="$vClass('footer__before')">
          <slot name="action-before"></slot>
        </div>
        <nxt-indicator-wrapper v-if="currentIndicator"
                               animate
                               :class="$vClass('progress_indicator')"
                               :nbIndicators="totalComparatorStep"
                               :current-indicator="currentIndicator">
        </nxt-indicator-wrapper>
        <div :class="$vClass('footer__after')">
          <slot name="action-after"></slot>
        </div>
      </sticky-card-footer>

    </el-card>
  </content-page>
</template>

<script>
import { mapGetters } from 'vuex';
import ContentPage from '@/components/layout/ContentPage.vue';
import LoadingIcon from '@/utils/components/LoadingIcon.vue';
import StickyCardFooter from '@/utils/components/StickyCardFooter.vue';

export default {
  name: 'step-comparator-wrapper',
  nameClassStyle: 'step-comparator-wrapper',
  components: {
    ContentPage,
    LoadingIcon,
    StickyCardFooter,
  },
  props: {
    cardFlex: Object,
    mobileWrapperColumn: {
      type: Boolean,
      default: true,
    },
    currentIndicator: Number,
    subtitle: String,
    title: String,
    loadingText: {
      type: String,
      default: 'Chargement en cours...',
    },
    otherLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sticking: false,
      observer: null,
    };
  },
  computed: {
    ...mapGetters({
      totalComparatorStep: 'configStore/totalComparatorStep',
    }),
  },
};
</script>

<style scoped lang="scss">
.step-comparator-wrapper {
  margin-bottom: 20px;

  &.--resume, &.--confirm, &.--payment, &.--services, &.--signature {
    .step-comparator-wrapper__content_card {
      @include breakpoint(tablet) {
        border-radius: var(--nxt-border-radius-base) var(--nxt-border-radius-base) 0 0;
      }
    }
  }
  :deep(.--font-weight-normal) {
    font-weight: normal;
  }
  & .loader {
    padding: calc(50vh - 155px) 0 calc(50vh - 155px);
    @include breakpoint('tablet') {
      padding: 100px 0 100px;
    }
    .loader__text {
      height: 20px;
    }
  }
  &__content_card {
    overflow: initial;
    &.el-card {
      border-radius: 0;
    }
  }
  &__content_wrapper {
    margin-bottom: 40px;
  }
  &__header {
    display: flex;
    margin-bottom: 16px;
    :deep(&__card-flex) {
      background-color: $--color-light-grey;
      .card-flex__img {
        width: 150px;
        height: auto;
      }
    }
  }
  .--font-weight-normal {
    font-weight: normal;
  }
  &__subtitle {
    flex: 1;
    margin: 0;
    font-size: $--font-size-large;
    font-family: "futura-pt", "Helvetica Neue", Helvetica, sans-serif;
  }

  &__progress_indicator {
    display: none;
    justify-self: center;
    @include breakpoint(mobile) {
      display: flex;
    }

    :deep(.indicator.valid) {
      background-color: var(--nxt-color-santas-gray);
    }
  }

  &__footer {
    display: grid;
    grid-template-columns: repeat( auto-fit, minmax(50px, 1fr) );
    justify-content: space-between;

    &__after {
      justify-self: end;
    }
  }
}
</style>
